import React, { useState } from "react";
import clsx from "classnames";
import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import { ArticleCard } from "@/components/ArticleCard";
import { CaseStudyCard } from "@/components/CaseStudyCard";
import styles from "./styles.module.scss";
import { getArticles } from "@/getters/getArticles";
import { getCaseStudies } from "@/getters/getCaseStudies";

export const CommunityCTA = ({ className, type = "Blogs" }) => {
  const [activeTab, setActiveTab] = useState(type);

  const articles = getArticles({ type: "Blogs" });
  const caseStudies = getCaseStudies();

  return (
    <div className={clsx(className, styles.CommunityCTA)}>
      <Container fluid="lg" className="py-5 py-md-6">
        <Stack
          className="flex-md-row flex-wrap justify-content-center mb-5"
          gap={{ xs: 0, md: 4 }}
        >
          <Button
            className={activeTab === "Blogs" ? "active" : "not-active"}
            onClick={() => setActiveTab("Blogs")}
          >
            Blogs
          </Button>
          <Button
            className={
              activeTab === "CaseStudies" ?  "active" : "not-active"
            }
            onClick={() => setActiveTab("CaseStudies")}
          >
            Case Studies
          </Button>
        </Stack>
        <Row>
          <Col xs={12}>
            <Row>
              {activeTab === "Blogs" &&
                articles.slice(0, 4).map((article, index) => (
                  <Col key={index} xs={12} lg={6} className="mb-4">
                    <ArticleCard {...article} />
                  </Col>
                ))}

              {activeTab === "CaseStudies" &&
                caseStudies.slice(0, 3).map((study, index) => (
                  <Col key={index} xs={12} lg={4} className="mb-4">
                    <CaseStudyCard {...study} variant="tall" />
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CommunityCTA;
